import styled from 'styled-components';

export const PageTitle = styled.h6`
    font-size: 2rem;
`

export const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AccordionItemWrapper = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin-bottom: 8px;
`;

export const AccordionHeaderButton = styled.button`
  width: 100%;
  padding: 16px 20px;
  display: grid;
  grid-template-columns: 32px 1fr auto;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
`;

export const AccordionHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AccordionTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: #174b92;
`;

export const AccordionIconLeft = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #f4a100;
`;

export const AccordionChevron = styled.span<{ open: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #174b92;          /* cor do ícone */
  transition: transform 0.2s ease;
  transform: ${({ open }) => (open ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

export const AccordionBody = styled.div`
  padding: 0 20px 16px 20px;
  color: #555555;
  font-size: 14px;
  line-height: 1.4;
`;
